import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { forwardRef } from "react";
import styles from "./list.module.css";
const ListInner = (props, ref) => {
    const { asChild = false, children, className, ...otherProps } = props;
    const Component = asChild ? Slot : "ul";
    return (_jsx(Component, { role: "list", ...otherProps, ref: asChild ? undefined : ref, className: clsx(styles.list, className), children: children }));
};
ListInner.displayName = "List";
const List = forwardRef(ListInner);
export { List };
